import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class CampaignStatusViewService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.CAMPAIGN_STATUS_VIEW = '/api/campaign-status-view';

        this.GET_BY_CAMPAIGN_RUN_ID = '/{campaignRunId}';
    }

    async getByCampaignRunId(campaignRunId) {
        try {
            let url = window.location.origin + this.CAMPAIGN_STATUS_VIEW + this.GET_BY_CAMPAIGN_RUN_ID;
            url = url
                .replace('{campaignRunId}', campaignRunId);
            const campaignStatusView = this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return campaignStatusView;
        } catch(err) {
            console.log(err);
        }
    }
}

export default CampaignStatusViewService;
